import React from 'react';

import { DashboardFooter } from '../components';
import { DashboardFooterProps } from '../components/DashboardFooter/DashboardFooter';

import styles from './Display.module.scss';

interface DisplayProps extends React.PropsWithChildren {
  healthInfo?: DashboardFooterProps['healthInfo'];
}

const Display: React.FC<DisplayProps> = ({ children, healthInfo }) => {
  return (
    <>
      <div className={styles.bg}></div>
      <div className={styles.wrapper}>
        {children}
        <DashboardFooter healthInfo={healthInfo} />
      </div>
    </>
  );
};

export default Display;
